"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDefaultDataLayer = exports.withDataLayerScript = void 0;

var react_1 = __importDefault(require("react"));

var common_tags_1 = require("common-tags");

var _ = __importStar(require("lodash"));

var Meta_1 = require("../Meta/Meta");
/**
 * Generate the dataLayer script.
 *
 * @param {any} dataLayer - The dataLayer Object.
 * @param {string} dataLayerName - The dataLayer name.
 *
 * Return {string} - Datalayer script.
 */


var generateDataLayer = function generateDataLayer(dataLayer, dataLayerName) {
  var result = "window." + dataLayerName + " = window." + dataLayerName + " || [];";

  if (dataLayer !== undefined) {
    Object.values(dataLayer).forEach(function (entry) {
      result += "window." + dataLayerName + ".push(" + JSON.stringify(entry) + ");";
    });
  }

  return common_tags_1.stripIndent(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), result);
};

var withDataLayerItem$ = function withDataLayerItem$(options) {
  return function (HelmetComponent) {
    return function (props) {
      var dataLayerName = props.dataLayerName,
          dataLayerData = props.dataLayerData,
          children = props.children,
          content = props.content,
          rest = __rest(props, ["dataLayerName", "dataLayerData", "children", "content"]);

      var path = options.path;
      var value = content !== undefined ? content : '';

      if (path) {
        _.set(dataLayerData, path, value);
      }

      return react_1.default.createElement(HelmetComponent, __assign({
        dataLayerName: dataLayerName,
        dataLayerData: dataLayerData
      }, rest));
    };
  };
};
/**
 * HOC that adds Default Datalayer to a Component
 */


var withDefaultDataLayer = function withDefaultDataLayer(dataLayer) {
  return function (HelmetComponent) {
    return function (props) {
      var defaultData = props.dataLayerData,
          rest = __rest(props, ["dataLayerData"]);

      if (defaultData !== undefined) {
        _.set(dataLayer, 'dataLayerData', __assign(__assign({}, defaultData), dataLayer.dataLayerData));
      }

      return react_1.default.createElement(HelmetComponent, __assign({}, dataLayer, rest));
    };
  };
};

exports.withDefaultDataLayer = withDefaultDataLayer;
var tagManagerEnabled = (process.env.GOOGLE_TAGMANAGER_ENABLED || '1') === '1';
/**
 * An HOC that renders the dataLayer scrip.
 *
 * @param HelmetComponent
 */

var withDataLayerScript = function withDataLayerScript(HelmetComponent) {
  return function (props) {
    if (!tagManagerEnabled) {
      return HelmetComponent;
    }

    var dataLayerData = props.dataLayerData,
        dataLayerName = props.dataLayerName,
        children = props.children,
        rest = __rest(props, ["dataLayerData", "dataLayerName", "children"]);

    return react_1.default.createElement(HelmetComponent, __assign({}, rest), children, react_1.default.createElement("script", null, generateDataLayer(dataLayerData, dataLayerName)));
  };
};

exports.withDataLayerScript = withDataLayerScript;
var withDataLayerItem = Meta_1.withHeadElement(withDataLayerItem$);
exports.default = withDataLayerItem;
var templateObject_1;